var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageFfffff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m0",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 0L0 0L0 24L24 24L24 0Z",
    fill: "#fff",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "m1",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 24L24 24L24 0L0 0L0 24Z",
    fill: "#fff",
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "m2",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 24L24 24L24 0L0 0L0 24Z",
    fill: "#fff",
    fillRule: "nonzero"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#m0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#m1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.02 0.018)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.04 12.875L19.773 19.511L4.268 19.511L0 12.875L12.02 0L24.04 12.875ZM1.775 13.035L5.035 18.105L19.005 18.105L22.266 13.035L12.02 2.061L1.775 13.035Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.887 12.252)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.266 0L22.266 1.406L0 1.406L0 0L22.266 0Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.402 12.603)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.826 0.741L1.195 6.594L0 5.853L3.631 0L4.826 0.741Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 7.772 12.603)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.826 5.853L3.631 6.594L0 0.741L1.195 0L4.826 5.853Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.038 12.595)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.923 5.853L3.738 6.61L0 0.757L1.185 0L4.923 5.853Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.039 12.595)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.923 0.757L1.185 6.61L0 5.853L3.738 0L4.923 0.757Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#m2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.493 0.844)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.835 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.976 11.925L3.631 12.334L0 0.41L1.345 0L4.976 11.925Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.204 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.976 0.41L1.345 12.334L0 11.925L3.631 0L4.976 0.41Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.804 20.343)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.406 0L1.406 2.813L0 2.813L0 0L1.406 0Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.031 20.164)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.983 1.989L1.989 2.983L0 0.994L0.994 0L2.983 1.989Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 20.164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.983 0.994L0.994 2.983L0 1.989L1.989 0L2.983 0.994Z",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageFfffff);
export default __webpack_public_path__ + "static/media/package-ffffff.be4262d2c56e10dd1c9ac95e30d2b70d.svg";
export { ForwardRef as ReactComponent };